import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SectionContainer, SectionHeader } from '../../../components/section';
import { UploadDocumentForm } from '../../../features/documents/upload-document-form';

/**
 * „Documente → Încarcă documente": un act adus de client, intrat în registru **cu număr**.
 *
 * Ruta a existat înaintea ecranului, ca intrarea de meniu de la #110 să ducă undeva care
 * spune ce urmează; de la [#108](https://github.com/bplugaru/efx-pcrm/issues/108) are
 * formularul. Adresa n-a fost schimbată — meniul o știe deja.
 *
 * **Același formular ca sertarul de pe fișa clientului**, cu o singură diferență: aici
 * clientul se caută. Pagina asta e drumul pentru „am un teanc de contracte și nu deschid
 * douăzeci de fișe"; sertarul e drumul pentru „sunt deja pe fișa lui".
 *
 * ⚠️ **Nu ține minte clientul între încărcări.** Formularul se remontează după fiecare act,
 * ca fișierul dinainte să nu rămână agățat într-un câmp care arată gol. Pentru un teanc al
 * **aceluiași** client, sertarul de pe fișă e drumul mai scurt.
 */
export const Route = createFileRoute('/_authenticated/documente/incarca')({
  component: IncarcaDocumentePagina,
});

function IncarcaDocumentePagina() {
  const navigate = useNavigate();

  return (
    <SectionContainer>
      <SectionHeader title="Încarcă documente" />

      <div className="flex flex-col gap-y-4 px-6 py-4">
        <UploadDocumentForm
          // Actul urcat se deschide imediat: definiția de gata a #108 cere să se poată vedea,
          // iar ecranul documentului îl arată în cadru — n-are text în spate, deci nici editor.
          onUploaded={(document) =>
            void navigate({ to: '/documente/$documentId', params: { documentId: document.id } })
          }
        />
      </div>
    </SectionContainer>
  );
}
